module.exports = __webpack_public_path__ + "img/6-4.c3fa2531.png";